<template>
  <div
    class="squircle-lg flex w-full flex-col gap-2 rounded border p-4"
    :class="{
      'col-span-2': element.thumbnail.format === 'extended'
    }"
  >
    <LoadingComponent v-if="!data" size="small" :display-label="false" />
    <template v-else>
      <div class="flex shrink-0 flex-row items-start gap-4">
        <RouterLink
          as="h3"
          class="group flex flex-1 items-center gap-1.5 truncate text-lg leading-none font-semibold hover:underline"
          :to="{
            name: 'analytics_element_route_id',
            params: { dashboardId, analyticsId: element.id }
          }"
        >
          <span class="truncate">{{ element.title }}</span>
          <FontAwesomeIcon
            :icon="['fal', 'chevron-right']"
            class="w-3 shrink-0 text-gray-400 group-hover:text-gray-600"
            size="xs"
          />
        </RouterLink>
        <div class="-mt-2 -mr-2 flex shrink-0 flex-row gap-1">
          <RouterLink
            class="squircle-lg flex size-6 items-center justify-center rounded border"
            :to="{
              name: 'analytics_element_route_id',
              params: { dashboardId, analyticsId: element.id }
            }"
          >
            <FontAwesomeIcon
              :icon="['fal', 'chart-mixed']"
              class="self-center"
              size="xs"
            />
          </RouterLink>
          <button
            class="squircle-lg flex size-6 items-center justify-center rounded border"
            @click="expandOrShrink"
          >
            <FontAwesomeIcon
              v-if="element.thumbnail.format === 'extended'"
              :icon="['fal', 'arrow-down-left-and-arrow-up-right-to-center']"
              class="self-center"
              size="xs"
            />
            <FontAwesomeIcon
              v-else
              :icon="['fal', 'arrow-up-right-and-arrow-down-left-from-center']"
              class="self-center"
              size="xs"
            />
          </button>
        </div>
      </div>
      <div class="flex max-h-52 min-h-0 flex-1 flex-row">
        <div class="relative flex min-w-0 flex-1 items-center lg:flex-2/5">
          <BarChart v-if="data.type === 'bar'" :chart-data="data.data" />
          <DoughnutChart
            v-else-if="data.type === 'doughnut'"
            ref="doughnutChart"
            :chart-data="data.data"
            :uniqid="uniqid"
          />
          <PieChart v-else-if="data.type === 'pie'" :chart-data="data.data" />
          <LineChar v-else-if="data.type === 'line'" :chart-data="data.data" />
        </div>
        <div
          :id="uniqid"
          :class="{
            hidden: element.thumbnail.format !== 'extended',
            'relative ml-4 aspect-square min-w-0 flex-1 overflow-auto text-sm lg:flex-3/5':
              element.thumbnail.format === 'extended'
          }"
        ></div>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import LoadingComponent from '@c/TheLoadingComponent.vue'
import BarChart from '@c/Dashboard/Content/Analytics/component/chart/BarChart.vue'
import DoughnutChart from '@c/Dashboard/Content/Analytics/component/chart/DoughnutChart.vue'
import PieChart from '@c/Dashboard/Content/Analytics/component/chart/PieChart.vue'
import LineChar from '@c/Dashboard/Content/Analytics/component/chart/LineChart.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default defineComponent({
  name: 'SimpleTile',
  components: {
    FontAwesomeIcon,
    LineChar,
    PieChart,
    DoughnutChart,
    BarChart,
    LoadingComponent
  },
  props: {
    element: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    uniqid: {
      type: String,
      required: true
    },
    dashboardId: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['update:element'],
  computed: {
    localElement: {
      get() {
        return this.element
      },
      set(value) {
        this.$emit('update:element', value)
      }
    }
  },
  methods: {
    expandOrShrink() {
      if (this.element.thumbnail.format === 'extended') {
        this.localElement.thumbnail.format = 'compact'
      } else {
        this.localElement.thumbnail.format = 'extended'
      }
      this.$refs.doughnutChart.renderChartData()
    }
  }
})
</script>
